import { QuoteForm } from "../components/Form/Forms/Quote/QuoteForm";
import { RatesTable } from "../components/Tables/RatesTable";
import { useGetQuote } from "../api/hooks";
import { ShipPageLayout } from "../components/Layouts/ShipPageLayout";
import { useRef, useEffect, useState } from "react";
import { useShipContext } from "../context/shipContext";
import { useNavigate } from "react-router-dom";
import { SELECT_QUOTE } from "../reducers/types";
import { PageHeading } from "../components/Headings/PageHeading";

export function Quote() {
  const { dispatch } = useShipContext();
  const {
    mutateAsync: getQuote,
    isLoading,
    isError,
    data,
    error,
  } = useGetQuote();
  const [quoteRequest, setQuoteRequest] = useState({});
  const tableRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.quotes?.length && tableRef.current) {
      setTimeout(
        () =>
          tableRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          }),
        150
      );
    }
  }, [data]);

  const handleSelectQuote = (quote) => {
    dispatch({ type: SELECT_QUOTE, payload: { quote, request: quoteRequest } });
    navigate("/dashboard/ship");
  };

  return (
    <ShipPageLayout>
      <div className="mb-20">
        <PageHeading title="Get a quote" withBreadcrumbs={true} />
      </div>

      <div className="space-y-8">
        <QuoteForm
          getQuote={getQuote}
          setQuoteRequest={setQuoteRequest}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />

        {data?.quotes && (
          <div ref={tableRef} className="space-y-4">
            {data.quotes.length > 0 ? (
              <RatesTable
                rates={data.quotes}
                onSelect={handleSelectQuote}
                cardStyle="bg-white rounded-xl shadow-sm hover:shadow-md transition p-4"
              />
            ) : (
              <div className="text-center text-gray-500 py-8 bg-gray-50 rounded-xl shadow-sm">
                No Results Found
              </div>
            )}
          </div>
        )}
      </div>
    </ShipPageLayout>
  );
}
